import client from '../client';
import type { Coupon, CreateCouponInput, UpdateCouponInput, CouponStats, CouponUsage } from '../../types/coupon';
import type { ApiResponse } from '../../types/api';

export const couponsApi = {
  list: async (storeId: string, params?: { archived?: boolean; page?: number; limit?: number; sort?: string; startDate?: string; endDate?: string }) => {
    const res = await client.get<ApiResponse<{ coupons: Coupon[]; pagination?: { page: number; limit: number; total: number; pages: number } }>>(
      `/dashboard/${storeId}/coupons`,
      { params },
    );
    return res.data.data!;
  },

  get: async (storeId: string, couponId: string) => {
    const res = await client.get<ApiResponse<{ coupon: Coupon; stats: CouponStats; usage: CouponUsage[] }>>(
      `/dashboard/${storeId}/coupons/${couponId}`,
    );
    return res.data.data!;
  },

  create: async (storeId: string, data: CreateCouponInput) => {
    const res = await client.post<ApiResponse<{ couponId: string }>>(
      `/dashboard/${storeId}/coupons`,
      data,
    );
    return res.data.data!;
  },

  update: async (storeId: string, couponId: string, data: UpdateCouponInput) => {
    await client.patch(`/dashboard/${storeId}/coupons/${couponId}`, data);
  },

  delete: async (storeId: string, couponId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/coupons/${couponId}`);
  },

  archive: async (storeId: string, couponId: string, archived = true): Promise<void> => {
    await client.post(`/dashboard/${storeId}/coupons/${couponId}/archive`, { archived });
  },
};
